var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUploadFile = function SvgIconUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 100,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-upload-file_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF9",
    d: "M50.413 85.629c20 0 36.214-16.214 36.214-36.286 0-20.071-16.286-36.285-36.214-36.285-20 0-36.215 16.214-36.215 36.285 0 20.072 16.215 36.286 36.215 36.286"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-upload-file_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-upload-file_svg__c)",
    d: "m74.864 77.659-48.311.346a5.084 5.084 0 0 1-5.1-5.006l-.374-46.222a5.07 5.07 0 0 1 4.999-5.095l48.311-.346a5.084 5.084 0 0 1 5.1 5.006l.375 46.222a5.07 5.07 0 0 1-5 5.095"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF9",
    d: "m72.144 70.758-42.47.321a2.15 2.15 0 0 1-2.18-2.14l-.322-38.2a2.144 2.144 0 0 1 2.136-2.178l42.47-.321a2.15 2.15 0 0 1 2.18 2.139l.322 38.2a2.144 2.144 0 0 1-2.136 2.179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7C4",
    d: "m51.605 56.42-15.493.108 7.68-8.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED6E2",
    d: "m64.453 56.316-22.333.16L53.18 43.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7C4",
    d: "M43.778 43.8a2.927 2.927 0 0 0 .308-4.127 2.927 2.927 0 0 0-4.128-.313 2.927 2.927 0 0 0-.308 4.128 2.927 2.927 0 0 0 4.128.313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M61.228 75.983a15 15 0 0 1-.941 2.769c-1.052 2.049-2.713 3.654-4.762 4.707-2.104 1.052-4.596 1.495-7.088.94-5.869-1.217-9.634-6.976-8.416-12.845s6.921-9.69 12.79-8.417c2.105.443 3.932 1.495 5.483 2.935 2.602 2.602 3.71 6.368 2.934 9.911"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.085 72.828h-2.492v-2.492a.933.933 0 0 0-.941-.942.933.933 0 0 0-.942.942v2.492H47.22a.933.933 0 0 0-.942.94c0 .555.388.942.942.942h2.491v2.492c0 .498.388.941.942.941a.933.933 0 0 0 .941-.941V74.71h2.492a.933.933 0 0 0 .941-.941.933.933 0 0 0-.941-.941"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-upload-file_svg__c",
    x1: 24.318,
    x2: 75.969,
    y1: 19.301,
    y2: 79.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-upload-file_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h100v100H.5z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-upload-file_svg__b",
    width: 88.785,
    height: 86.67,
    x: 6.078,
    y: 17.335,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_604_538527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_604_538527",
    result: "shape"
  })))));
};
export default SvgIconUploadFile;